import $ from 'jquery';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';
import View_Merged_Feedback from 'view/feedback_sidebar/merged_feedback';
import View_User_Data from 'view/user_data';
import View_Custom_Data from 'view/feedback_sidebar/custom_data';

export default View.extend({
    views: {
        merged_feedback: {},
        user_data: {},
        custom_data: {}
    },

    pending_xhr: [],

    events: {
        'click .item-header-collapsible' : 'onToggleItem'
    },

    dom_handlers: {
        onToggleItem: function(e) {
            e.stopPropagation();

            var item_element = $(e.currentTarget).parents('.session-item:first');
            var item_name = item_element.data('val');

            item_element.toggleClass('open');

            var open_items = Cache.get('feedback_sidebar_open_items') ? Cache.get('feedback_sidebar_open_items').split(',') : [];

            // save in cookie
            if (item_element.hasClass('open')) {
                open_items.push(item_name);
            } else {
                open_items = open_items.filter((item) => {
                    return item !== item_name;
                });
            }

            Cache.add('feedback_sidebar_open_items', open_items.join(','), true);
        }
    },

    initialize: function(options) {
        this.dispatcher = options.dispatcher;

        this.views.user_data = new View_User_Data({
            identification : this.model.get('user_identification'),
            sidebar : true
        });

        this.views.merged_feedback = new View_Merged_Feedback({ model: this.model });
        this.views.custom_data = new View_Custom_Data({model: this.model,});

        this.listenTo(this.model, 'change:user_identification', this.renderUserData);

        this.on('remove', () => {
            this.pending_xhr.forEach((pending_xhr) => {
                pending_xhr.abort();
            });
        });
    },

    renderUserData: function() {
        this.views.user_data.setId(this.model.get('user_identification'));
        this.views.user_data.render();
    },

    render: function() {
        var device  = ''
        var os      = ''
        var os_icon = '';

        if (this.model.isTablet()) {
            device += ' (Tablet)';
        } else if (this.model.isPhone()) {
            device += ' (Mobile)';
        }

        os = this.model.getOs();

        if (this.model.isAndroid()) {
            os_icon = '<i class="fab fa-android text-android"></i> ';
        } else if (this.model.isApple()) {
            os_icon = '<i class="fab fa-apple"></i> ';
        } else if (this.model.isWindowsPhone() || this.model.isWindows()) {
            os_icon = '<i class="fab fa-windows text-windows"></i> ';
        } else if (this.model.isLinux()) {
            os_icon = '<i class="fab fa-linux"></i> ';
        } else {
            os_icon = '';
        }

        var feedback_system =  os_icon + os + device;
        var feedback_browser = this.model.getBrowserIcon() + this.model.getBrowser('');

        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        var render_more = !Cache.app.isClient();

        var open_items = Cache.get('feedback_sidebar_open_items') ? Cache.get('feedback_sidebar_open_items').split(',') : [];

        var content =
        '<div class="session-item' + (open_items.includes('metadata') ? ' open' : '') + '" data-val="metadata">' +
            '<div class="item-header item-header-collapsible">' +
                '<span>Metadata</span>' +
            '</div>' +
            '<div class="item-content">' +
                '<div class="box-neutral-light">' +
                    '<div class="info-grid">' +
                        // feedback source
                        '<div class="info-title">Source:</div>' +
                        '<div class="info-value">' + Util.htmlEntities(this.model.getSource()) + '</div>' +

                        // vote count
                        (this.model.getVoteCount() ?
                        '<div class="info-title">Vote:</div>' +
                        '<div class="info-value">' + this.model.getVoteCount() + '</div>' : '') +

                        // page
                        '<div class="info-title">Page:</div>' +
                        '<div class="info-value">' +
                            (this.model.get('page') ?
                            '<a class="ellipsis-inline" title="' + this.model.escape('page') + '" href="' + this.model.escape('page') + '" target="_blank" rel="noopener">' + this.model.escape('page') + '</a>' +
                            (this.model.get('page_title') ?
                            '<div class="ellipsis info text-small" title="' + this.model.escape('page_title') + '">' + this.model.escape('page_title') + '</div>' : '') :
                            '<span class="text-info">-</span>') +
                        '</div>' +

                        // rating
                        (this.model.get('rating') ?
                        '<div class="info-title">Rating:</div>' +
                        '<div class="info-value rating-details">' + this.model.getRatingIcon() + '</div>' : '') +

                        // system
                        '<div class="info-title">System:</div>' +
                        '<div class="info-value">' + (feedback_system || '<span class="text-info">-</span>') + '</div>' +

                        // browser
                        '<div class="info-title">Browser:</div>' +
                        '<div class="info-value">' + (feedback_browser || '<span class="text-info">-</span>') + '</div>' +

                        // screen size
                        '<div class="info-title">Screen size:</div>' +
                        '<div class="info-value">' +
                            (this.model.get('window_x') && this.model.get('window_y') ?
                            '<div class="margin-bottom-4">' + this.model.get('window_x') + ' x ' + this.model.get('window_y') + '<br><span class="info text-small">Browser window</span></div>' : '') +

                            (this.model.get('resolution_x') && this.model.get('resolution_y') ?
                            '<div>' + this.model.get('resolution_x') + ' x ' + this.model.get('resolution_y') + '<br><span class="info text-small">Resolution</span></div>' : '')+

                            (!this.model.get('window_x') && !this.model.get('window_y') && !this.model.get('resolution_x') && !this.model.get('resolution_y') ? '<span class="text-info">-</span>' : '') +
                        '</div>' +

                        // dpi
                        '<div class="info-title">DPI:</div>' +
                        '<div class="info-value">' + (this.model.get('dpi') > 0 ? this.model.escape('dpi') : '<span class="text-info">-</span>') + '</div>' +

                        // colour depth
                        '<div class="info-title">Color depth:</div>' +
                        '<div class="info-value">' + (this.model.get('colour_depth') ? this.model.escape('colour_depth') + '-bit' : '<span class="text-info">-</span>') + '</div>' +

                        // location
                        '<div class="info-title">Location:</div>' +
                        '<div class="info-value">' + (this.model.get('city') ? this.model.escape('city') + ' ' + this.model.escape('country') + ' ' + this.model.escape('postal') : '<span class="text-info">-</span>') + '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +

        (render_more ?
        '<hr class="small">' +
        '<div class="session-item region-user-data' + (open_items.includes('userdata') ? ' open' : '') + '" data-val="userdata"></div>' +
        '<hr class="small">' +
        '<div class="session-item region-custom-data' + (open_items.includes('customdata') ? ' open' : '') + '" data-val="customdata"></div>' +
        '<hr class="small">' +
        '<div class="session-item region-merged-feedback' + (open_items.includes('mergedfeedback') ? ' open' : '') + '" data-val="mergedfeedback"></div>' +
        '<hr class="small">' : '');

        this.$el.html(content);

        if (!Cache.app.isClient()) {
            this.views.merged_feedback.render().$el.appendTo(this.$el.find('.region-merged-feedback'));
        }

        if (render_more) {
            this.views.user_data.render().$el.appendTo(this.$el.find('.region-user-data'));
            this.views.custom_data.render().$el.appendTo(this.$el.find('.region-custom-data'));
        }

        return this;
    }
});